import type {ReactAction} from '@netx/core/bootstrap';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {DownloadRequestActionLabel} from '../locales';
import {type IDownloadRequest, DownloadRequestReviewStatus} from '../schema';

export const downloadRequestActionDenyAllIcon = faTimes;

export type DownloadRequestActionDenyAllParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (downloadRequest: IDownloadRequest) => void;
};

/**
 * @param params
 * @returns Action
 */
export const downloadRequestActionDenyAll = (
	downloadRequest: IDownloadRequest,
	{cb, ...params}: DownloadRequestActionDenyAllParams,
): ReactAction => ({
	name: 'download-request-deny-all',
	cb: () => cb(downloadRequest),
	enableTest: () =>
		downloadRequest.reviewStatus === DownloadRequestReviewStatus.PENDING,
	icon: downloadRequestActionDenyAllIcon,
	label: DownloadRequestActionLabel.DENY_ALL,
	...params,
});
